import _ from 'lodash'
export const setFormData =
  (formId: string, root_code:string, form_code: string, dirty:boolean, data:any = {}, resetOrig = false) =>
    ({getState}) => {
        const original = _.cloneDeep(resetOrig ? data : _.get(getState(), `formData.data.${formId}.original`, data) )
        console.log("SET FORM DATA", formId, root_code, form_code, dirty, data, getState())
        return {
            type: '@formData/UPDATE_SUCCESS',
            payload: {id: formId, root_code, form_code, dirty, data, original}
        };
    };

export const clearFormData =
    (formId: string) =>
        ({getState}) => {
            console.log('DELETING FORM DATA', formId)
            return {
                type: '@formData/DELETE_SUCCESS',
                payload: formId
            };
        };

export const resetFormData =
    (formId: string, key = 'data') =>
        ({getState}) => {
            const {root_code, form_code, data = {}, original = {}} = _.get(getState(), `formData.data.${formId}`, {} )
            console.log("RESET FORM DATA", getState(), formId, root_code, form_code, original)
            return {
                type: '@formData/UPDATE_SUCCESS',
                payload: {id: formId, root_code, form_code, dirty:false, data: _.clone( key === 'data' ? original : data ), original: _.clone( key === 'data' ? original : data) }
            };
        };



